import React, { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { Statuses } from 'flow/types/Extension';

import { useAppSelector } from 'flow/hooks/useRedux';
import { selectExtensionStatus } from 'flow/selectors/ExtensionSelectors';
import SupervisorAgentPopover from 'flow/components/pbx/supervisor/SupervisorAgentPopover';
import SimplePopover from 'flow/components/ui-components/SimplePopover';

interface Props {
    agentKey: ExtensionKey;
}

const inCall = (status: Statuses) =>
    status === 'inCall' || status === 'inExternalCall';

const SupervisorBarAgent = ({ agentKey }: Props) => {
    const [isHovered, setIsHovered] = useState(false);
    const [referenceElement, setReferenceElement] = useState<any>();
    const agentStatus = useAppSelector((state) =>
        selectExtensionStatus(state, agentKey),
    );

    return (
        <div className="flex h-3 w-2 hover:h-4 hover:w-3">
            <div
                className={twMerge(
                    'relative flex w-full rounded-xs',
                    inCall(agentStatus) ? 'bg-red' : 'bg-green',
                )}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                ref={setReferenceElement}
            />
            {isHovered ? (
                <SimplePopover
                    referenceElement={referenceElement}
                    placement="bottom"
                >
                    <SupervisorAgentPopover agentKey={agentKey} />
                </SimplePopover>
            ) : null}
        </div>
    );
};

export default React.memo(SupervisorBarAgent);
